function exactlyOnHalfCent (cents) {
  return cents % 1 === 0.5
}

export default function roundMoney (amount) {
  const cents = amount * 100
  const roundedCents = exactlyOnHalfCent(cents)
    ? Math.floor(cents)
    : Math.round(cents)
  return roundedCents / 100
}
